import { computed, ref } from "vue";

// keeps track of the window width, accessible via getters
export const windowWidth = ref(window.innerWidth);

export const useBreakpoints = () => {
    const onWidthChange = () => {
        windowWidth.value = window.innerWidth;
    };
    /*
     * Install a single event listener to keep track of the window width,
     * this is used in Vue plugin @/Plugins/breakpoints.js
     */
    const installEventListener = () => {
        window.addEventListener("resize", onWidthChange);
    };

    const breakpoints = {
        "2xs": 320,
        xs: 560,
        sm: 640,
        md: 768,
        lg: 1024,
        xl: 1280,
        "2xl": 1536,
    };

    const width = computed(() => windowWidth.value);

    const type = computed(() => {
        if (width.value < breakpoints["2xs"]) return "3xs";
        if (width.value < breakpoints["xs"]) return "2xs";
        if (width.value < breakpoints["sm"]) return "xs";
        if (width.value < breakpoints["md"]) return "sm";
        if (width.value < breakpoints["lg"]) return "md";
        if (width.value < breakpoints["xl"]) return "lg";
        if (width.value < breakpoints["2xl"]) return "xl";
        return "2xl";
    });

    const maxMobile = computed(() => width.value < breakpoints["sm"]);

    const maxSmall = computed(() => width.value < breakpoints["md"]);

    const maxTablet = computed(() => width.value < breakpoints["lg"]);

    const minLarge = computed(() => width.value > breakpoints["lg"] - 1);

    const minExtraLarge = computed(() => width.value > breakpoints["xl"] - 1);

    return {
        breakpoints,
        width,
        type,
        maxMobile,
        maxSmall,
        maxTablet,
        minLarge,
        minExtraLarge,
        installEventListener,
    };
};
